module.exports = __webpack_public_path__ + "img/07_shimizu_11.a2b660c5.jpg";